module.exports = __webpack_public_path__ + "Woman-with-laptop-wallpaper.97c65dfe28d9af463841.png";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/imgs/dashboard/Woman-with-laptop-wallpaper.png
// module id = ../../../../../src/assets/imgs/dashboard/Woman-with-laptop-wallpaper.png
// module chunks = main